import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Smile, Gem } from "lucide-react";
import AppointmentForm from "../components/AppointmentForm";
import FAQ from "../components/FAQ";
import TestimonialsSection from "../components/TestimonialsSection";
import CTASection from "../components/CTASection";

export default function Estetica() {
  const faqs = [
    { q: "¿Cuánto dura un blanqueamiento dental?", a: "Los resultados pueden durar entre 1 y 3 años dependiendo de los hábitos de cada paciente. Ofrecemos sesiones de mantenimiento para prolongar los resultados." },
    { q: "¿Qué son las carillas dentales?", a: "Las carillas son láminas finas de porcelana o composite que se adhieren a la parte frontal del diente para mejorar su forma, color y alineación. Son ideales para diseños de sonrisa." },
    { q: "¿El blanqueamiento daña el esmalte?", a: "No, si se realiza bajo supervisión profesional. Usamos agentes blanqueadores de grado clínico con tratamientos desensibilizantes." },
    { q: "¿Puedo hacerme un diseño de sonrisa en una visita?", a: "El diseño de sonrisa suele requerir 2-3 visitas. En la primera estudiamos tu caso con escáner digital y te mostramos una simulación del resultado final." },
  ];
  return (
    <div data-testid="estetica-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
                <span className="text-xs font-semibold text-teal-700 uppercase">Estética dental</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Diseña tu sonrisa <span className="underline-accent">perfecta</span>
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                Blanqueamiento dental profesional, carillas de porcelana, diseño de sonrisa digital.
                Luce la sonrisa que siempre soñaste con tratamientos de alta gama.
              </p>
              <Link to="/contacto" className="btn-primary" data-testid="estetica-cta-top">
                Consulta gratuita <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100">
              <h3 className="text-xl font-bold text-slate-900 mb-5">Reserva tu consulta de estética</h3>
              <AppointmentForm defaultService="Estética dental / Blanqueamiento" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-max">
          <div className="max-w-3xl mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">Tratamientos estéticos</h2>
            <p className="text-lg text-slate-600">Soluciones para cada tipo de sonrisa, con resultados naturales.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Sparkles, title: "Blanqueamiento", desc: "Resultados visibles en 1 hora. Técnica profesional segura." },
              { icon: Gem, title: "Carillas dentales", desc: "Porcelana ultrafina para una sonrisa armoniosa." },
              { icon: Smile, title: "Diseño de sonrisa", desc: "Planificación digital 3D antes de cualquier intervención." },
            ].map((item, i) => (
              <div key={i} className="bg-teal-50 rounded-3xl p-8" data-testid={`estetica-treatment-${i}`}>
                <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsSection limit={3} />
      <FAQ items={faqs} title="Preguntas sobre estética dental" />
      <CTASection />
    </div>
  );
}
